import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { GoDotFill } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { NumberFormatter } from "../../../CommonFunction/common";
import { getFirstAndLastDatesFromMonthName } from "../../../CommonFunction/getFirstAndLastDatesOfMonth";
import { convertToISO } from "../../../CommonFunction/IsoDateTime";
import useProcessData from "../../../CommonFunction/ProcessData";
import { getFields } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable } from "../../Components";
import AddLedger from "../../Components/FormComponents/Ledger/AddLedger";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import Loading from "../../Components/Loading/Loading";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "./AccountLedger.scss";

export const AccountDetailsForLedger = (fields = []) => {
  console.log(fields, "fieldsfieldsfieldsfields");
  return gql`
    query GetVoucherEntriesRelatedToAccountIDAndOpeningInRange($fromDate: ISODate, $toDate: ISODate, $accountId: ID) {
      GetVoucherEntriesRelatedToAccountIDAndOpeningInRange(
        From_Date: $fromDate
        To_Date: $toDate
        AccountID: $accountId
      ) {
        GetClosingAndOpeningBalancesInRange {
          Opening_Balance
          finalOpeningAmount
          finalOpeningType
          finalClosingType
          finalClosingAmount
          Account_Name
          Unique_Id
          AccountData {
            Account_Group_Name
            _id
           Account_Type
          }
        }
        GetVoucherEntriesRelatedToAccountID {
          _id
          ${fields?.join(" ")}
        }
      }
    }
  `;
};

export const AccountVoucher = () => {
  let Key = "Account_Vouchers";
  const [loadingState, setLoading] = useState(true);
  const [openViewPortal, setOpenViewPortal] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const colAddition = ["Credit", "Debit"];
  const { FromDate, ToDate } = useSelector((state) => state?.financialYear?.SelectedDate);
  const { id } = useParams();
  const [Closing, setLastClosing] = useState();
  const [ClosingType, setClosingType] = useState("");
  const [Opening, setLastOpening] = useState();
  const [OpeningType, setOpeningType] = useState("");
  const [TableHeaders, setFieldsToShowInTableHeaders] = useState([]);
  const location = useLocation();
  const month = location.state?.monthData;

  const [getCurrentField] = useLazyQuery(getFields, {
    fetchPolicy: "cache-and-network",
    onError: (err) => {
      ErrorToast(`Failed to fetch the Fields `);
    },
  });

  const [RefetchAccountData, { data: AccountData, error }] = useLazyQuery(AccountDetailsForLedger([]), {
    fetchPolicy: "network-only",
    variables: {
      fromDate: FromDate,
      toDate: ToDate,
      accountId: id,
    },
  });

  const [formData, setFormData] = useState(
    AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange
      ? AccountData.GetVoucherEntriesRelatedToAccountID
      : []
  );

  const config = useMemo(
    () => ({
      dataKey: "GetVoucherEntriesRelatedToAccountID",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
      dateKeysWithoutTime: ["Date"],
    }),
    []
  );

  useEffect(() => {
    if (month) {
      const { firstDate, lastDate } = getFirstAndLastDatesFromMonthName(month.month);
      const ISOFirstDate = convertToISO(firstDate);
      const ISOLastDate = convertToISO(lastDate);

      if (ISOFirstDate) {
        sessionStorage.setItem("SelectedFromDate", JSON.stringify(ISOFirstDate));
      }
      sessionStorage.setItem("SelectedToDate", JSON.stringify(ISOLastDate));
      dispatch({
        type: "SET_SELECTED_DATE",
        payload: { FromDate: ISOFirstDate, ToDate: ISOLastDate },
      });
      getCurrentField({
        variables: {
          Table_Key: Key,
        },
      }).then(({ data }) => {
        var fields = data?.GetUserTableColumnManagementWithUserId_Page_ID.filter((item) => item.Status).map(
          (item) => item?.Field_Name
        );
        const fieldsToShowInTableHeadersData = data?.GetUserTableColumnManagementWithUserId_Page_ID.filter(
          (item) => item.Status
        ).map((item) => [item?.Field_Name, item?.Table_Column_Name, item?.Column_Total ? item?.Field_Name : null]);
        setFieldsToShowInTableHeaders(fieldsToShowInTableHeadersData);
        RefetchAccountData({
          query: AccountDetailsForLedger(fields),
          fetchPolicy: "network-only",
          variables: {
            fromDate: ISOFirstDate,
            toDate: ISOLastDate,
            accountId: id,
          },
        });
      });
    }
  }, []);

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  useEffect(() => {
    setLoading(true);
    if (AccountData) {
      console.log(AccountData);

      setLastClosing(
        AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
          ?.finalClosingAmount
      );
      setClosingType(
        AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
          ?.finalClosingType
      );
      setLastOpening(
        AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
          ?.finalOpeningAmount
      );
      setOpeningType(
        AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
          ?.finalOpeningType
      );
    }
    setLoading(false);
  }, [AccountData]);

  const handleClick = (event) => {
    console.log(event, AccountData)
    if (event.ctrlKey) {
      let accData =
        AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange.GetClosingAndOpeningBalancesInRange
          ?.AccountData;
      dispatch({
        type: "UNIQUE_TABLE_LIST",

        payload: {
          key: "Account_Vouchers",
          data: {
            Selected_Rows: [accData],
            Selected_Row: accData,
            SelRow_id: [accData?._id],
            SelRow_ids: [accData?._id],
          },
        },
      });
      setShow(true);
      setOpenViewPortal(true);
    }
  };

  const isTally =
    formData &&
    formData.length !== 0 &&
    Math.abs(Number(Closing?.toFixed(2))) == Math.abs(formData[formData.length - 1]?.Closing_Balance);
  const { loading } = useFetchTableData(AccountDetailsForLedger, RefetchAccountData, setLoading, Key);
  const { loading: processDataLoading } = useProcessData(
    AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange,
    setFormData,
    config,
    error
  );
  const isLoading = loadingState || processDataLoading || loading;

  return (
    <div>
      <HeaderDiv title="Account Vouchers" TableKey={"Account_Vouchers"} MoreActions={{ Is_Back: true, }} />
      <div className="AccountDetailsDiv">
        <div>
          <p className="heading">Account</p>
          <div onClick={handleClick} className="AccountName">
            <p>
              {
                AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
                  ?.Account_Name
              }
            </p>
            <p className="uniqueID">
              {AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange?.GetClosingAndOpeningBalancesInRange
                ?.AccountData?.Unique_Id || ""}
            </p>
          </div>
        </div>
        <div>
          <p className="heading">Opening Balance</p>
          <p>{AccountData && `${NumberFormatter(Opening)} ${OpeningType}`}</p>
        </div>
        <div>
          <p className="heading">Closing Balance</p>
          <p className="closingBalance">
            <>
              {AccountData && `${NumberFormatter(Closing)} ${ClosingType}`}
              <GoDotFill className={isTally ? "tallyTick" : "notTally"} />
            </>
          </p>
        </div>
      </div>

      {isLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {isLoading && <div className="loader-line-div" />}
          <LoadTable
            data={formData}
            loading={isLoading}
            error={error}
            title="Account_Vouchers"
            ledgerTable={true}
            colAddition={colAddition}
            TableHeaders={TableHeaders}
          />
        </>
      )}

      {openViewPortal ? (
        <AddLedger
          AccountID={
            AccountData?.GetVoucherEntriesRelatedToAccountIDAndOpeningInRange.GetClosingAndOpeningBalancesInRange
              ?.AccountData?._id
          }
          show={show}
          setShow={setShow}
          ParentPortalCloseFunction={() => {
            setOpenViewPortal(false);
            setShow(false);
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};
